import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';

interface Props {
  tag?: string | null;
  size?: string | null;
  align?: string | null;
  weight?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbTitle',
  props: {
    tag: null,
    size: null,
    align: null,
    weight: null
  },
  setup(__props: any) {

const props = __props as {
  tag?: string | null;
  size?: string | null;
  align?: string | null;
  weight?: string | null;
};



const state = computed(() => {
  return {
    tag: props.tag || 'h1',
    size: props.size || 'md',
    align: props.align || 'center',
    weight: props.weight || 'bold',
  };
});

return { __sfc: true,props, state }
}

})